
import { useMemo } from 'react';
import Axios from 'axios';
import DefaultConstants from '../data/Constants';
import { useNotificationContext } from '../contexts/NotificationContext';
import { useUserContext } from '../contexts/UserContext';
import { authTokenStorage } from './StorageHelper';
import { useLanguageContext } from '../contexts/LanguageContext';
import { HttpStatusEnum } from '../data/Enums';
import { IBackendException } from '../interfaces/IException';
import LanguageHelper from './LanguageHelper';


const AxiosHelper = Axios.create({
    baseURL: DefaultConstants.apiUrl
});


const AxiosInterceptor = (props: React.PropsWithChildren) => {
    const { translate } = useLanguageContext();
    const { handleLogout } = useUserContext();
    const { showLoading, hideLoading, showToast } = useNotificationContext();

    useMemo(() => {
        AxiosHelper.interceptors.request.clear();
        AxiosHelper.interceptors.request.use((config) => {
            showLoading();
            return config;
        }, (err) => {
            return Promise.reject(err);
        });

        AxiosHelper.interceptors.response.clear();
        AxiosHelper.interceptors.response.use((resp) => {
            hideLoading();

            if (resp.data.authToken) {
                const authToken: string = resp.data.authToken;
                authTokenStorage.set(authToken);
            }

            const response = resp.data as IBackendException;
            if (response.parameter !== undefined && response.parameter.length > 0) {
                let message = LanguageHelper.TranslationExists(response.parameter) ? response.parameter : '_defaultOnSuccess';
                showToast("success", translate(message));
            }

            return Promise.resolve(resp);
        }, (err) => {
            hideLoading();

            const exception = err.response.data as IBackendException;
            if (exception.parameter !== undefined && exception.parameter.length > 0) {
                let message = LanguageHelper.TranslationExists(exception.parameter) ? exception.parameter : '_defaultOnError';
                showToast("warning", translate(message));
            }

            switch (err.response.status) {
                case HttpStatusEnum.Unauthorized:
                    handleLogout();
                    break;
            }
            
            return Promise.reject(err);
        });

        // eslint-disable-next-line
    }, [translate]);


    return <>
        {props.children}
    </>;
}

export {
    AxiosHelper
}

export default AxiosInterceptor;